import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { calcShelfTableProps } from '@aytm/app/stats/page/question-views/ec/lib/shelf-table-utils'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

// components
import Controls from '@aytm/app/stats/page/question-views/ec/components/shelf/Controls'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import ShelfNote from '@aytm/app/stats/page/question-views/sh/components/shelf/ShelfNote'

// The shelf half of an ecommerce question: a collapse toggle over the "Shop Metrics"
// summary table. Unlike the shelf-test question there is no shelf image or heatmap here —
// shelf_block.coffee never built one — but the note about differing shelves still applies.
const ShelfBlock = ({
  id,
  answer,
  viewMode,
  format,
  components,
  priceTemplate,
  shelfPreviewData,
  shelfCollapsed,
  onShelfCollapsedChange
}) => {
  const tableProps = calcShelfTableProps({ answer, viewMode, format, priceTemplate, shelfPreviewData })

  return (
    <>
      {isComponentOn(components, 'controls') && (
        <Controls chartCollapsed={shelfCollapsed} onToggle={onShelfCollapsedChange} />
      )}
      {!shelfCollapsed && isComponentOn(components, 'table') && <Table id={id} {...tableProps} />}
      <ShelfNote />
    </>
  )
}

ShelfBlock.displayName = 'EcommerceShelfBlock'

ShelfBlock.propTypes = {
  id: PropTypes.string,
  answer: answerPropType,
  viewMode: PropTypes.string,
  format: PropTypes.object,
  components: PropTypes.object,
  priceTemplate: PropTypes.string,
  shelfPreviewData: PropTypes.object,
  shelfCollapsed: PropTypes.bool,
  onShelfCollapsedChange: PropTypes.func
}

export default ShelfBlock
